import { render, staticRenderFns } from "./ListTags.vue?vue&type=template&id=0ca4b0e0"
import script from "./ListTags.vue?vue&type=script&lang=js"
export * from "./ListTags.vue?vue&type=script&lang=js"
import style0 from "./ListTags.vue?vue&type=style&index=0&id=0ca4b0e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports